export const MOTION_STORAGE_KEY = 'branch-staff-motion';
export const ENHANCED_LOADING_STORAGE_KEY = 'branch-staff-enhanced-loading';
export const MOTION_CHANGE_EVENT = 'staff-motion-change';
export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const motionDurationsMs = Object.freeze({
  press: 120,
  feedback: 150,
  open: 220,
  close: 160,
  celebration: 2500,
  illustration: 2800,
  illustrationStagger: 100
});
export const motionEaseOut = 'cubic-bezier(0.23, 1, 0.32, 1)';

const getPreference = (key) => {
  try {
    return window.localStorage.getItem(key) === 'on';
  } catch {
    return false;
  }
};

const savePreference = (key, enabled) => {
  try {
    window.localStorage.setItem(key, enabled ? 'on' : 'off');
    window.dispatchEvent(new Event(MOTION_CHANGE_EVENT));
    return true;
  } catch {
    return false;
  }
};

export const getMotionPreference = () => getPreference(MOTION_STORAGE_KEY);
export const saveMotionPreference = (enabled) => savePreference(MOTION_STORAGE_KEY, enabled);
export const getEnhancedLoadingPreference = () => getPreference(ENHANCED_LOADING_STORAGE_KEY);
export const saveEnhancedLoadingPreference = (enabled) => savePreference(ENHANCED_LOADING_STORAGE_KEY, enabled);

export const motionOffVariables = Object.fromEntries(
  Object.keys(motionDurationsMs).map((name) => [`--motion-duration-${name}`, '0ms'])
);
export const motionVariables = {
  ...Object.fromEntries(
    Object.entries(motionDurationsMs).map(([name, ms]) => [`--motion-duration-${name}`, `${ms}ms`])
  ),
  '--motion-ease-out': motionEaseOut
};

// Read the input mode at the trigger so keyboard activation never waits for an effect.
export const getDisclosureTimeout = () => {
  const root = document.documentElement;
  return root.dataset.motion === 'on' &&
    root.dataset.input === 'pointer' &&
    !window.matchMedia?.(REDUCED_MOTION_QUERY).matches
    ? { enter: motionDurationsMs.open, exit: motionDurationsMs.close }
    : 0;
};
